module.exports = __webpack_public_path__ + "23de03f0eae59ab0d50d131c69b0b005.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/owlfonso-waving.png
// module id = 542
// module chunks = 0